import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
import Button from 'react-bootstrap-button-loader';
import LoadingLayer from '../../controls/LoadingLayer';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch';
import { GetLanguage } from '../../../utils/language';
import { loadLocalization } from '../../../utils/kendoLocalization';
import moment from "moment";
import "moment/locale/fr";
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import AlertAlgo from '../../controls/AlertSnack'
import * as StatusCode from '../../../scripts/StatusCode';

import { isEmpty, formatDate, formatDateTimeNET } from '../../../utils';
import { saveAvailability } from '../../../actions/availability';
import styles from '../../../styles/scheduleAvailability.module.css';

import { withNamespaces } from 'react-i18next';

import { TimePicker } from '@material-ui/pickers'

loadLocalization();
moment.locale("fr");

const useStyles = makeStyles((theme) => ({
    rootProfile: {
        overflow: 'auto'
    },
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    divForm: {
        padding: '10px'
    },
    date: {
        marginBottom: '15px'
    },
    divButtons: {
        textAlign: 'center',
        marginTop: '10px'
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    timePicker: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    }
}));

function AvailabilityForm(props) {
    const classes = useStyles();

    let currentDate = new Date();
    currentDate = currentDate.toLocaleDateString('en-CA');
    const hourDefault = '08:00';

    const [scheduleAvailabilityId, setScheduleAvailabilityId] = useState(0);
    const [startTime, setStartTime] = useState(`${currentDate} ${hourDefault}`);
    const [endTime, setEndTime] = useState(`${currentDate} ${hourDefault}`);
    const [oldStartTime, setOldStartTime] = useState(null);
    const [oldEndTime, setOldEndTime] = useState(null);
    const [sunday, setSunday] = useState(false);
    const [monday, setMonday] = useState(false);
    const [tuesday, setTuesday] = useState(false);
    const [wednesday, setWednesday] = useState(false);
    const [thursday, setThursday] = useState(false);
    const [friday, setFriday] = useState(false);
    const [saturday, setSaturday] = useState(false);
    const [shift, setShift] = useState(null);
    const [lineId, setLindId] = useState(0);
    const [isProcessing, setIsProcessing] = useState(true);
    const [data, setData] = useState([]);
    const [locale, setLocale] = useState(GetLanguage());

    const alertRef = useRef(null);

    useEffect(() => {
        setIsProcessing(false);
    }, []);

    useEffect(() => {
        setScheduleAvailabilityId(props.scheduleAvailabilityId);
    }, [props.scheduleAvailabilityId]);

    useEffect(() => {
        if (props.lineId > 0) {
            setLindId(props.lineId);
        } else {
            clearForm();
        }
    }, [props.lineId]);

    useEffect(() => {
        if (lineId > 0) {
            setIsProcessing(true);
            loadEdit();
            setIsProcessing(false);
        }
    }, [lineId])

    useEffect(() => {
        if (data.id > 0) {
            setStartTime(`${currentDate} ${data.startTime}`);
            setEndTime(`${currentDate} ${data.endTime}`);
            setOldStartTime(`${currentDate} ${data.startTime}`);
            setOldEndTime(`${currentDate} ${data.endTime}`);
            setSunday(data.day1);
            setMonday(data.day2);
            setTuesday(data.day3);
            setWednesday(data.day4);
            setThursday(data.day5);
            setFriday(data.day6);
            setSaturday(data.day7);
            setShift(data.shift);
        }
    }, [data]);

    const clearForm = () => {
        setStartTime(`${currentDate} ${hourDefault}`);
        setEndTime(`${currentDate} ${hourDefault}`);
        setSunday(false);
        setMonday(false);
        setTuesday(false);
        setWednesday(false);
        setThursday(false);
        setFriday(false);
        setSaturday(false);
    }

    const loadEdit = () => {
        const dataFiltered = props.data.filter(x => x.id == scheduleAvailabilityId && x.lineId == lineId)[0];
        setData(dataFiltered);
    }

    const handleReloadList = () => {
        props.handleReloadList();
    }

    const isValidData = () => {
        let message = '';

        if (isEmpty(startTime)) {
            message = i18next.t('scheduleAvailability:availability.message.startTime-form');
        } else if (isEmpty(endTime)) {
            message = i18next.t('scheduleAvailability:availability.message.endTime-form');
        } else if (new Date(startTime) >= new Date(endTime)
            && (new Date(startTime).getHours() !== 0 && new Date(startTime).getMinutes() !== 0
                && new Date(endTime).getHours() !== 0 && new Date(endTime).getMinutes() !== 0)) {
            message = i18next.t('scheduleAvailability:availability.message.endTimeGreaterThanStartTime');
        } else if (!sunday && !monday && !tuesday && !wednesday && !thursday && !friday && !saturday) {
            message = i18next.t('scheduleAvailability:availability.message.days-form');
        }

        if (message.length > 0) {
            showMessageError(message);
            return false;
        }

        return true;
    }

    const handleSave = async () => {
        if (isValidData()) {
            const startTimeFormatted = formatDateTimeNET(formatDate(new Date(startTime), 'datetime'));
            const endTimeFormatted = formatDateTimeNET(formatDate(new Date(endTime), 'datetime'));
            const oldStartTimeFormatted = oldStartTime !== null ? formatDateTimeNET(formatDate(new Date(oldStartTime), 'datetime')) : null;
            const oldEndTimeFormatted = oldEndTime !== null ? formatDateTimeNET(formatDate(new Date(oldEndTime), 'datetime')) : null;
            const response = await saveAvailability(scheduleAvailabilityId, startTimeFormatted, endTimeFormatted,
                oldStartTimeFormatted, oldEndTimeFormatted, shift, sunday, monday, tuesday, wednesday, thursday, friday, saturday);

            if (response == null || (response != null && response.status != StatusCode.STATUS_OK)) {
                // Error
                showMessageError(i18next.t('error:generic-error'));
                return;
            };

            if (response.result[0].codeReturn <= -1) {
                // Error
                showMessageError(response.result[0].message);
                return;
            };

            handleReloadList();
        }
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const onStartTimeChange = (date) => {
        setStartTime(date);
    }

    const onEndTimeChange = (date) => {
        setEndTime(date);
    }

    const onChangeSunday = (event) => {
        setSunday(event.target.checked);
    }

    const onChangeMonday = (event) => {
        setMonday(event.target.checked);
    }

    const onChangeTuesday = (event) => {
        setTuesday(event.target.checked);
    }

    const onChangeWednesday = (event) => {
        setWednesday(event.target.checked);
    }

    const onChangeThursday = (event) => {
        setThursday(event.target.checked);
    }

    const onChangeFriday = (event) => {
        setFriday(event.target.checked);
    }

    const onChangeSaturday = (event) => {
        setSaturday(event.target.checked);
    }

    return (
        <div id={"divAvailabilityForm"} className={styles.rootSchedulePopBody}>
            <LoadingLayer isActive={isProcessing}>
                <FormControl className={classes.date} fullWidth>
                    <MuiPickersUtilsProvider utils={MomentUtils} libInstance={moment} locale={locale}>
                        <KeyboardTimePicker
                            onKeyDown={(event) => { event.preventDefault() }}
                            invalidDateMessage={i18next.t('common:incorrectTime')}
                            ampm={false}
                            margin="normal"
                            id="startTimePicker"
                            label={i18next.t('scheduleAvailability:availability.form.startTime')}
                            value={startTime}
                            minutesStep={15}
                            onChange={onStartTimeChange}
                            className={classes.timePicker + ' required'}
                            cancelLabel={i18next.t('buttons:cancel')}
                            keyboardIcon={<AccessTimeIcon />}
                            KeyboardButtonProps={{
                                'aria-label': 'change time',
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </FormControl>

                <FormControl className={classes.date} fullWidth>
                    <MuiPickersUtilsProvider utils={MomentUtils} libInstance={moment} locale={locale}>
                        <KeyboardTimePicker
                            onKeyDown={(event) => { event.preventDefault() }}
                            invalidDateMessage={i18next.t('common:incorrectTime')}
                            ampm={false}
                            margin="normal"
                            id="endTimePicker"
                            label={i18next.t('scheduleAvailability:availability.form.endTime')}
                            value={endTime}
                            minutesStep={15}
                            onChange={onEndTimeChange}
                            className={classes.timePicker + ' required'}
                            cancelLabel={i18next.t('buttons:cancel')}
                            keyboardIcon={<AccessTimeIcon />}
                            KeyboardButtonProps={{
                                'aria-label': 'change time',
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </FormControl>

                <FormControl className={styles.switchComponent} fullWidth>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={sunday}
                                onChange={onChangeSunday}
                                name="monday"
                                variant="success"
                            />
                        }
                        label={i18next.t("weekday:week.sunday")}
                        labelPlacement="start"
                    />
                </FormControl>

                <FormControl className={styles.switchComponent} fullWidth>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={monday}
                                onChange={onChangeMonday}
                                name="monday"
                                variant="success"
                            />
                        }
                        label={i18next.t("weekday:week.monday")}
                        labelPlacement="start"
                    />
                </FormControl>

                <FormControl className={styles.switchComponent} fullWidth>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={tuesday}
                                onChange={onChangeTuesday}
                                name="monday"
                                variant="success"
                            />
                        }
                        label={i18next.t("weekday:week.tuesday")}
                        labelPlacement="start"
                    />
                </FormControl>

                <FormControl className={styles.switchComponent} fullWidth>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={wednesday}
                                onChange={onChangeWednesday}
                                name="monday"
                                variant="success"
                            />
                        }
                        label={i18next.t("weekday:week.wednesday")}
                        labelPlacement="start"
                    />
                </FormControl>

                <FormControl className={styles.switchComponent} fullWidth>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={thursday}
                                onChange={onChangeThursday}
                                name="monday"
                                variant="success"
                            />
                        }
                        label={i18next.t("weekday:week.thursday")}
                        labelPlacement="start"
                    />
                </FormControl>

                <FormControl className={styles.switchComponent} fullWidth>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={friday}
                                onChange={onChangeFriday}
                                name="monday"
                                variant="success"
                            />
                        }
                        label={i18next.t("weekday:week.friday")}
                        labelPlacement="start"
                    />
                </FormControl>

                <FormControl className={styles.switchComponent} fullWidth>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={saturday}
                                onChange={onChangeSaturday}
                                name="monday"
                                variant="success"
                            />
                        }
                        label={i18next.t("weekday:week.saturday")}
                        labelPlacement="start"
                    />
                </FormControl>

                <div className="formDivButtons">
                    <Button className="saveButton" onClick={handleSave} variant="success">
                        {i18next.t('buttons:save')}
                    </Button>
                </div>
                <AlertAlgo ref={alertRef} />
            </LoadingLayer>
        </div>
    );
}

export default withNamespaces(['buttons', 'scheduleAvailability', 'weekday', 'error', 'common'], { wait: true })(AvailabilityForm);